import { render, staticRenderFns } from "./PdfHeader.vue?vue&type=template&id=3ac99975"
import script from "./PdfHeader.vue?vue&type=script&lang=js"
export * from "./PdfHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports